export const glCodes = {
	'RoU Asset - Initial Recognition': 'rouAssetInitialRecognition',
	'RoU Asset - Modification': 'rouAssetModification',
	'RoU Asset - Pre-payment': 'rouAssetPrepayments',
	'RoU Asset - Upfront Payment': 'rouAssetUpfrontPayment',
	'RoU Asset - Indirect Costs': 'rouAssetIndirectCosts',
	'RoU Asset - Cash Incentive': 'rouCashIncentive',
	'RoU Asset - Knock Off': 'rouAssetKnockOff',
	'Security Deposit': 'securityDeposit',
	'Lease Liability - Initial Recognition': 'leaseLiabilityInitialRecognition',
	'Lease Liability - Modification': 'leaseLiabilityModification',
	'Lease Liability - Payment': 'leaseLiabilityPayment',
	'Lease Liability - Interest': 'leaseLiabilityInterest',
	'Interest Expense': 'interestExpense',
	'Depreciation - RoU': 'depreciationRou',
	'Accum Depreciation - RoU': 'accumDepreciationRouDepreciation',
	'Accum Depreciation - RoU - Knock Off': 'accumDepreciationRouKnockOff',
	'A/P Control Ledger - Pre-payment': 'apControlLedgerPrepayments',
	'A/P Control Ledger - Upfront Payment': 'apControlLedgerUpfrontPayment',
	'A/P Control Ledger - Indirect Costs': 'apControlLedgerIndirectCosts',
	'A/P Control Ledger - Security Deposit': 'apControlLedgerSecurityDeposit',
	'A/P Control Ledger - Payment': 'apControlLedgerPayment',
	'A/R Control Ledger - Cash Incentive': 'arCashIncentive',
};

export const glCodesToShow = {
	'RoU Asset - Initial Recognition': 'gl_rouAssetInitialRecognition',
	'RoU Asset - Modification': 'gl_rouAssetModification',
	'RoU Asset - Pre-payment': 'gl_rouAssetPrepayments',
	'RoU Asset - Upfront Payment': 'gl_rouAssetUpfrontPayment',
	'RoU Asset - Indirect Costs': 'gl_rouAssetIndirectCosts',
	'RoU Asset - Cash Incentive': 'gl_rouCashIncentive',
	'RoU Asset - Knock Off': 'gl_rouAssetKnockOff',
	'Security Deposit': 'gl_securityDeposit',
	'Lease Liability - Initial Recognition': 'gl_leaseLiabilityInitialRecognition',
	'Lease Liability - Modification': 'gl_leaseLiabilityModification',
	'Lease Liability - Payment': 'gl_leaseLiabilityPayment',
	'Lease Liability - Interest': 'gl_leaseLiabilityInterest',
	'Interest Expense': 'gl_interestExpense',
	'Depreciation - RoU': 'gl_depreciationRou',
	'Accum Depreciation - RoU': 'gl_accumDepreciationRouDepreciation',
	'Accum Depreciation - RoU - Knock Off': 'gl_accumDepreciationRouKnockOff',
	'A/P Control Ledger - Pre-payment': 'gl_apControlLedgerPrepayments',
	'A/P Control Ledger - Upfront Payment': 'gl_apControlLedgerUpfrontPayment',
	'A/P Control Ledger - Indirect Costs': 'gl_apControlLedgerIndirectCosts',
	'A/P Control Ledger - Security Deposit': 'gl_apControlLedgerSecurityDeposit',
	'A/P Control Ledger - Payment': 'gl_apControlLedgerPayment',
	'A/R Control Ledger - Cash Incentive': 'gl_arCashIncentive',
};

export const glCodesShort = {
	'RoU Assets': 'rouAssets',
	'Lease Liabilities - ST': 'leaseLiabilityST',
	'Lease Liabilities - LT': 'leaseLiabilityLT',
	'Interest Expense': 'interestExpense',
	'Lease Payables': 'leasePayables',
	'Security Deposit': 'securityDeposit',
	Depreciation: 'depreciation',
	'Accumulated Depreciation': 'accumulatedDepreciation',
	'Gain from Leases': 'gainFromLeases',
	'Loss from Leases': 'lossFromLeases',
};

export const glCodesShortForShow = {
	'RoU Assets': 'gl2_rouAssets',
	'Lease Liabilities - ST': 'gl2_leaseLiabilityST',
	'Lease Liabilities - LT': 'gl2_leaseLiabilityLT',
	'Interest Expense': 'gl2_interestExpense',
	'Lease Payables': 'gl2_leasePayables',
	'Security Deposit': 'gl2_securityDeposit',
	Depreciation: 'gl2_depreciation',
	'Accumulated Depreciation': 'gl2_accumulatedDepreciation',
	'Gain from Leases': 'gl2_gainFromLeases',
	'Loss from Leases': 'gl2_lossFromLeases',
};
